import BaseLikeButton, { BaseLikeButtonProps } from "./BaseLikeButton";

const ActivityLikeButton: React.FC<BaseLikeButtonProps> = (props) => {
  return <BaseLikeButton {...props} border></BaseLikeButton>;
};

export default ActivityLikeButton;
